import React from 'react';
import type { StepIconProps } from '@material-ui/core';
import { Box, useTheme } from '@material-ui/core';
import { Tooltip } from '@klp/design/index';
import BlockIcon from '@material-ui/icons/Block';

type ConditionalStepIconProps = StepIconProps & {
    skalHoppeOver?: boolean;
    translationKey?: string;
};

export const ConditionalStepIcon = ({
    icon,
    active,
    completed,
    className,
    skalHoppeOver,
    translationKey,
}: ConditionalStepIconProps) => {
    const theme = useTheme();

    if (skalHoppeOver) {
        return (
            <Tooltip translation={translationKey} title="">
                <Box
                    className={`${className} MuiStepIcon-root`}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 30,
                        height: 30,
                        fontWeight: 500,
                    }}
                >
                    <BlockIcon fontSize="medium" color="error" />
                </Box>
            </Tooltip>
        );
    }

    return (
        <Box
            className={`${className} MuiStepIcon-root`}
            style={{
                width: 30,
                height: 30,
                borderRadius: '50%',
                backgroundColor:
                    completed || active ? '#0DB189' : theme.palette.grey[400],
                color: completed
                    ? theme.palette.common.white
                    : theme.palette.common.white,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 500,
                fontSize: '0.75rem',
            }}
        >
            {icon}
        </Box>
    );
};
